/* eslint-disable */
import ko from 'knockout';
import Base from '@bingads-webui-static-legacy/bulk-edit/viewmodel/bulkEditJob';
import PageContext from '@bingads-webui-static-legacy/page-context';
import * as DatePicker from '@bingads-webui-campaign/campaigns-date-picker';
import config from '@bingads-webui-component-legacy/config/index';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var disableKeywordDestinationUrl = PageContext.Permissions.IsKeywordDestinationURLDisabled;
var titleStrings = {
  'ad': function (count) {
    if (count === 1) {
      return i18n.getString('BulkEdit_PasteOneAd_Title');
    } else if (count > 1) {
      return i18n.getString('BulkEdit_PasteNAds_Title', count);
    } else {
      return i18n.getString('BulkEdit_PasteUnknownAds_Title');
    }
  },
  'keyword': function (count) {
    if (count === 1) {
      return i18n.getString('BulkEdit_PasteOneKeyword_Title');
    } else if (count > 1) {
      return i18n.getString('BulkEdit_PasteNKeywords_Title', count);
    } else {
      return i18n.getString('BulkEdit_PasteUnknownKeywords_Title');
    }
  },
  'campaign': function (count) {
    if (count === 1) {
      return i18n.getString('BulkEdit_PasteOneCampaign_Title');
    } else if (count > 1) {
      return i18n.getString('BulkEdit_PasteNCampaigns_Title', count);
    } else {
      return i18n.getString('BulkEdit_PasteUnknownCampaigns_Title');
    }
  },
  'adgroup': function (count) {
    if (count === 1) {
      return i18n.getString('BulkEdit_PasteOneAdGroup_Title');
    } else if (count > 1) {
      return i18n.getString('BulkEdit_PasteNAdGroups_Title', count);
    } else {
      return i18n.getString('BulkEdit_PasteUnknownAdGroups_Title');
    }
  },
  'assetgroup': function (count) {
    if (count === 1) {
      return i18n.getString('BulkEdit_PasteOneAssetGroup_Title');
    } else if (count > 1) {
      return i18n.getString('BulkEdit_PasteNAssetGroups_Title', count);
    } else {
      return i18n.getString('BulkEdit_PasteUnknownAssetGroups_Title');
    }
  }
};
var ViewModel = function (model, startDatePicker, endDatePicker) {
  Base.call(this);
  this.contentType = ko.observable('');
  this.includeBids = ko.observable(true);
  this.disableKeywordDestinationUrl = disableKeywordDestinationUrl;
  this.includeDestinationURLs = ko.observable(true);
  this.pauseAfterPasting = ko.observable(false);
  this.ignoreRowSelection = ko.observable(true);
  this.showPreviewButton = ko.observable(false);
  this.actionButtonText = ko.observable(i18n.getString('BulkEdit_PasteButton'));
  this.statusText = ko.observable(i18n.getString('BulkEdit_Paste_InitialStatus'));
  this.adjustStartAndEndDates = ko.observable(false);
  this.endDateModification = ko.observable(null);
  this.showCheckBoxes = ko.observable(true);
  this.isCampaignAdGroupCopyPasteOperation = ko.observable(model.attributes.content.type === 'campaign' || model.attributes.content.type === 'adgroup');
  this.culture = config.get('culture') || 'en-US';
  this.format = config.get('globalization.datetime.shortDatePattern') || 'M/d/yyyy';
  this.titleText = ko.computed(function () {
    var title = titleStrings[this.contentType()];
    return title ? title(model.get('content').count) : '';
  }, this);
  startDatePicker.on('dateChanged', () => {
    this.errorMessage('');
  });
  endDatePicker.on('dateChanged', () => {
    this.errorMessage('');
  });
  this.validate = function () {
    if (this.adjustStartAndEndDates() && this.endDateModification() === 'Selected') {
      var startDate = startDatePicker.getState().selectedDate;
      var endDate = endDatePicker.getState().selectedDate;
      if (startDate > endDate) {
        this.errorMessage(i18n.getString('DatePicker_StartDateCannotBeLaterThanEndDate'));
        return false;
      }
    }
    return ViewModel.validateTab(this.contentType());
  };
};
export default ViewModel;

